export default __webpack_public_path__ + "static/043-ed978cea2c3d9e1ad3107bf782d41285.png";